import { api } from "@/shared/lib/api";

/**
 * Приглашение во временную («турнирную») команду.
 *
 * KAN-1641: путь приглашения у временной команды другой — `/invite/temp-roster/<token>`,
 * а не `/invite/roster/<token>` (постоянный ростер). Владелец маршрута — бэкенд:
 * он отдаёт `invitePath` целиком, и клиент не должен собирать URL у себя. Тот же
 * контракт уже используют панель временных команд и панель Arena-составов.
 */
type TempInviteResponse = { invitePath?: string | null };

const requireInvitePath = (response: TempInviteResponse | null | undefined) => {
  const invitePath = response?.invitePath;
  if (!invitePath) {
    throw new Error("Сервер не вернул путь приглашения временной команды");
  }
  return invitePath;
};

/** Текущая (или только что созданная) ссылка-приглашение временной команды. */
export async function getTempTeamInvitePath(teamId: string): Promise<string> {
  const response = await api.get<TempInviteResponse>(
    `/TournamentTeams/teams/${teamId}/temp-invite`,
  );
  return requireInvitePath(response.data);
}

/** Перевыпуск приглашения: старая ссылка после этого недействительна. */
export async function reissueTempTeamInvitePath(
  teamId: string,
): Promise<string> {
  const response = await api.post<TempInviteResponse>(
    `/TournamentTeams/teams/${teamId}/temp-invite/reissue`,
  );
  return requireInvitePath(response.data);
}
